// extracted by mini-css-extract-plugin
module.exports = {"light":"TaskFilter_light__Z5ek6","dark":"TaskFilter_dark__2-9Hc","selected":"TaskFilter_selected__1CIQw"};